import { SKETCH_WEBSITE } from '@sketch/constants'

export const CANVAS_VIEW_DOCS = `${SKETCH_WEBSITE}/docs/canvas-view`
export const MIN_ZOOM = 0.01
export const MAX_ZOOM = 5
